<template>
    <v-card flat class="pa-5">
  
      <!-- Select asset transaction date -->
      <v-menu
        :close-on-content-click="false"  
        v-model="assetdatepicker"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          v-model="liabilityInvoiceDate"
          label="Date"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker v-model="liabilityInvoiceDate" @input="assetdatepicker = false" />
      </v-menu>
  
      <!-- All asset transaction done on firm -->
      <v-select
        v-model="selectedFirmFromAsset"
        :items="firmsByBrand"
        label="Select Firm"
        required
      >
          <template slot="selection" slot-scope="data">
              {{ data.item.text }}
          </template>
          <template slot="item" slot-scope="data">
              <v-list-tile-content>
                  <v-list-tile-title v-html="`${data.item.firm.name}${data.item.firm.proprietor ? ' | '+data.item.firm.proprietor : '' } | ₹: ${(data.item.firm.amount || 0).toLocaleString()}`" />
              </v-list-tile-content>
          </template>
          </v-select>
              <v-select 
                  :items="staffByBrand"
                  v-model="selectStaff" 
                  label="Select Staff Account"
                  >
              </v-select>
  
                 <!-- Addition or deletion on asset if old -->
              <v-select
                  v-if=" selectedFirmFromAsset && selectStaff"
                  v-model="addition"
                  label="Select transaction type"
                  :items="getTransactionTypeOptions"
              />
              <v-text-field
                  v-if=" selectedFirmFromAsset && selectStaff && addition"
                  type="number"
                  label="Amount"
                  v-model="additionAmount"
              />
              
  
              <!-- asset payement type -->
              <v-select
                  dense
                  v-if="additionAmount"
                  label="Select Transaction Payment Type"
                  v-model="operationPaymentType"
                  :items="paymentOptions"
              />
              <!-- if cash&bank: ask for both value for seperate deduction -->
              <v-text-field 
                  v-if="operationPaymentType === 'CashAndBank Account'"
                  v-model="operationAmountFromCash" 
                  type="number"
                  label="Transactionn Amount to Pay From Cash"
                  :error-messages="(Number(operationAmountFromCash) + Number(operationAmountFromBank)) != Number(additionAmount) && operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []"
              />
              <v-text-field
                  v-if="operationPaymentType === 'CashAndBank Account'"
                  v-model="operationAmountFromBank"
                  type="number"
                  label="Transactionn Amount to Pay From Bank"
                  :error-messages="(Number(operationAmountFromCash) + Number(operationAmountFromBank)) != Number(additionAmount) && operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []"
              />
              <v-select
                  v-if="operationPaymentType && operationPaymentType !== 'Cash'"
                  v-model="operationAccountForTransaction"
                  :items="otherAccountByBrand"
                  label="Bank Account to Pay operation amount from Bank"
                  required
              >
                  <template slot="selection" slot-scope="data">
                      {{ data.item.text }}
                  </template>
                  <template slot="item" slot-scope="data">
                      <v-list-tile-content>
                          <v-list-tile-title v-html="`${data.item.text}
                              ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                              ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                              | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                          " />
                      </v-list-tile-content>
                  </template>
              </v-select>
  
          <!-- add asset remark for  invoice/asset add-->
          <v-text-field 
              v-if="additionAmount && operationPaymentType" 
              label="Remark" 
              v-model="staffRemark">
          </v-text-field>
      
  
      <v-btn color="primary" @click="liabilityAmountClick">
        <v-icon right dark>money_off</v-icon>Save
      </v-btn>
      <v-btn color="primary" @click="$router.go(-1)">
        <v-icon left dark>cancel</v-icon>Cancel
      </v-btn>
      <v-btn color="primary" @click="openLiabilityTable = true">
        View Details
      </v-btn>
      
      <v-dialog
          fullScreen
          v-model="openLiabilityTable"
          transition="dialog-bottom-transition"
      >
          <v-toolbar card dark color="primary">
              <v-toolbar-title>Liability Details</v-toolbar-title>
              <v-spacer/>
              <v-btn icon dark @click.native="openLiabilityTable = false">
                  <v-icon>close</v-icon>
              </v-btn>
          </v-toolbar>
          <v-card>
              <liability-table-info
               :accountsByBrand="accountsByBrand" 
              :firmsByBrand="firmsByBrand"
              :staffAccount="staffAccount"
              :paymentOptions="paymentOptions"
              @notify="notify"
               />
          </v-card>
      </v-dialog>
    </v-card>
  </template>
  <script>
  
  import { createNamespacedHelpers } from "vuex";
  const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
  import {
      ASSET_TYPE_WITH_DEPRICIATION,
      ASSET_CATEGORY,
      ASSET_PURCHASE_TYPE,
      PAYMENT_OPTIONS,
      getFinancialYear
  } from './utils';
  
  import liabilityTableInfo from '../table/liabilityTable.vue';
  
  export default {
      name: 'liabilityTab',
      props: {
          selectedBrand: { type: String, default: '' },
          accountsByBrand: { type: Array },
          firmsByBrand: { type: Array },
          assetByBrand: {type: Array },
          staffAccount: {type: Array },
      },
      components: {
          liabilityTableInfo
      },
      data() {
          return {
              // open asset table dialog
              openLiabilityTable: false,
              assetdatepicker: false,
  
              liabilityInvoiceDate: null,
              selectedFirmFromAsset: this.firmsByBrand.find((item)=> item.defaultFirm),
  
              // when asset age is new: account id from which money will be deducted
              selectAccountFromAsset: null,
  
              selectAsset:null,
              staffRemark:null,
  
              operationPaymentType: null,
              amountFromCash: null,
              amountFromBank: null,
  
              addition: null,
              additionAmount: null,
              operationAccountForTransaction: null,
              operationAmountFromCash: null,
              operationAmountFromBank: null,
              selectStaff:null,
              asset: {},
          }
      },
      computed: {
          ...mapGlobalGetters(["brandFinYear"]),
          staffByBrand() {
              if(this.selectedFirmFromAsset) {
                  return this.staffAccount.filter
                    (item => item.staff.firm === this.selectedFirmFromAsset)
              }
              return []
          },
          getTransactionTypeOptions() {
              return [
                {text: 'Debit', value: 'liability'},
                // {text: 'Advance', value: 'advance'},
                // {text: 'Commission', value: 'commission'},
                {text: 'Credit', value: 'return'}
              ] 
            },
          assetTypeList() { return ASSET_TYPE_WITH_DEPRICIATION},
          assetCategoryList() { return ASSET_CATEGORY },
          assetPurchaseType() { return ASSET_PURCHASE_TYPE },
          paymentOptions() { return PAYMENT_OPTIONS },
          financialYear() { return getFinancialYear() },
          isAssetPurchaedInfinancialYear() {
              if(this.selectAsset && this.assetPurchaseDate && this.selectedAssetDetail.isVerified) {
                  return this.financialYear.includes(this.assetPurchaseDate.split('-')[0])
              }
              return false
          },
          accountsByFirm() {
              if(this.selectedFirmFromAsset) {
                  return this.accountsByBrand.filter(item => item.account.firm === this.selectedFirmFromAsset)
              }
              return []
          },
          otherAccountByBrand() {
              return this.accountsByFirm.filter(account => account.account.accountType !== 'Loan A/C')
          },
          loanAccountByBrand() {
              return this.accountsByFirm.filter(account => account.account.accountType === 'Loan A/C')
          },
          allowDepriciation() {
              const list = this.assetTypeList.find(item => item.value === this.asset.type)
              if(list) {
                  return !!list.depriciation
              }
              return false
          },
          depriciationList() {
              const list = this.assetTypeList.find(item => item.value === this.asset.type)
              if(list && list.depriciation !== false) {
                  return list.depriciation
              }
              return []
          },
          selectedAssetDetail() {
              const asset = this.assetByBrand.find(asset => asset['value'] === this.selectAsset)
              if(asset) {
                  this.asset = asset.asset
                  return asset.asset
              }
              return null;
          },
          assetEditDisabled() {
              if(this.selectedAssetDetail) {
                  return !!this.selectedAssetDetail.isVerified
              }
              return false;
          },
          selectedFirmDetailToPay() {
              if(this.selectedFirmFromAsset) {
                  return this.firmsByBrand.find(item => item.value === this.selectedFirmFromAsset).firm;
              }
              return null
          },
          selectedBankAccountDetailToPay() {
              if(this.selectAccountFromAsset) {
                  return this.accountsByBrand.find(item => item.value === this.selectAccountFromAsset).account;
              }
              return null
          }
      },
      created() {
          this.$bindAsObject('firmById', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
          this.$bindAsObject('bankById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand))
          this.$bindAsObject('staffById', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand))
          let today = new Date()
          this.liabilityInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
      },
      methods: {
          
          // Income Functionality
          liabilityAmountClick: async function(e){
            var self=this;
  
              const asset = {
                  brand: this.selectedBrand,
              }
  
              if(!this.selectedFirmFromAsset) {
                  return this.$emit('notify', 'select firm')        
              }
  
              if(!this.addition) {
                  return this.$emit('notify', 'Select transaction type');
              }
  
              if(!this.additionAmount) {
                  return this.$emit('notify', 'Add amount')
              } else {
                  asset.totalAdditionAmount = (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount)
              }
  
              if(this.operationPaymentType === 'CashAndBank Account' && (!this.operationAmountFromCash || !this.operationAmountFromBank)) {
                  return this.$emit('notify', 'Enter amount to pay from bank and cash for operation')
              }
              if(this.operationPaymentType !== 'Cash' && !this.operationAccountForTransaction) {
                  return this.$emit('notify', 'Select Bank account for operation')
              }
  
              let transactionError = false;
                  if(this.addition != 'return'){
                      const firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
                      const accountBalance = this.operationAccountForTransaction ? this.bankById[this.operationAccountForTransaction].amount : 0;
                      switch(this.operationPaymentType) {
                          case 'Cash':
                              if(this.additionAmount > firmBalance) {
                                  transactionError = `Insufficiant balance in firm ${firmBalance}`;
                                  break;
                              }
                              break;
                          case "Bank Account":
                              if(this.additionAmount > accountBalance) {
                                  // Insufficient balance in bank account
                                  transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`
                                  break;
                              }
                              break;
                          case "CashAndBank Account":
                              if(Number(this.additionAmount) !== Number(this.operationAmountFromCash) + Number(this.operationAmountFromBank)) {
                                  transactionError = 'Total of by cash and bank amount should be same as operation Amount!';
                                  break;
                              }
                              if(this.operationAmountFromCash > firmBalance) {
                                  transactionError = `Insufficiant balance in firm ${firmBalance}`;
                                  break;
                              }
                              if(this.operationAmountFromBank > accountBalance) {
                                  // Insufficient balance in bank account
                                  transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`
                                  break;
                              }
                              break;
                      }
                  }
                  if(transactionError) {
                      return this.$emit('notify', transactionError);
                  }
  
  
  
              // liability adance commostion debite
              let globStaffType = this.staffById[this.selectStaff].staffRole;
              
  
              let liabilityData = {
                  brand: this.selectedBrand,
                  firm: this.selectedFirmFromAsset,
                  staffId: this.selectStaff,
                  staffType: globStaffType,
                  transactionType: this.addition, //liability etc
                  paymentType:this.operationPaymentType,
                  amount: Number(this.additionAmount),
                  date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now(),
                  remark : this.staffRemark
              }
  
              if(this.addition != 'return'){
  
                  liabilityData.isCredited = true;
  
                  // create a invoice data now
                  if(this.operationPaymentType == 'Cash'){  
                      
                      
  
                      const invoiceCashData = {
                          brand: this.selectedBrand,
                          brandFinYear : this.brandFinYear,
                          firm: this.selectedFirmFromAsset,
                          type:'automatic invoice',
                          transactionType: 'Staff',
                          paymentType:this.operationPaymentType,
                          accountNumber:'',
                          isCredited:false,
                          totalAmount:Number(this.additionAmount),
                          remark: this.staffRemark,
                          staffkey: this.selectStaff,
                          staffType: globStaffType,
                          date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now(),
                      }
  
                      var firm = this.firmById[invoiceCashData.firm];
                          firm.amount = firm && firm.amount - invoiceCashData.totalAmount;
                          this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);
  
                          invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                          invoiceCashData.liabilityType = this.addition;
                          let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
                          liabilityData['invoiceIdCash'] = res.key;
                          liabilityData['amountFromCash'] = invoiceCashData['totalAmount'];
                      
                    //   this.$root.$firebaseRefs.firm.child(this.selectedFirmFromAsset).once('value').then( function(snap) {
                    //       if(Number(snap.val().amount) >= invoiceCashData.totalAmount){
                    //           self.$root.$firebaseRefs.firm.child(invoiceCashData.firm).update({
                    //                   amount: Number(snap.val().amount) - Number(invoiceCashData.totalAmount)
                    //           });
  
                    //           self.snackbarSuccess=true;
                    //           self.snackbarSuccessText = "staff amount paid";
                              
                    //           invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                    //           self.$root.$firebaseRefs.invoice.push(invoiceCashData);
  
                    //           self.additionAmount = null;
                    //           self.selectedFirmFromAsset = null;
                    //           self.staffRemark = null;
                    //       }else{
                    //           return this.$emit('notify', 'Insufficient Balance To Pay');
                    //       }
                    //   })
                  }else if(this.operationPaymentType == 'Bank Account'){
                      
                      let invoiceViaAccount = {
                            brand: this.selectedBrand,
                            brandFinYear : this.brandFinYear,
                            firm:this.selectedFirmFromAsset,
                            type:'automatic invoice',
                            transactionType: 'Staff',
                            paymentType:this.operationPaymentType,
                            isCredited:false,
                            totalAmount:Number(this.additionAmount),
                            remark: this.staffRemark,
                            staffkey: this.selectStaff,
                            staffType: globStaffType,
                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                        }
  
                          invoiceViaAccount.amountFromBank = invoiceViaAccount.totalAmount;
                          invoiceViaAccount.bank = this.operationAccountForTransaction
  
                          if(invoiceViaAccount.bank) {
                              invoiceViaAccount.accountNumber = this.bankById[invoiceViaAccount.bank].accountnumber;
                          }
  
                          var firm = this.firmById[invoiceViaAccount.firm];
                          var bank = this.bankById[invoiceViaAccount.bank];
  
                          bank.amount = bank && bank.amount - invoiceViaAccount.totalAmount;
                          this.$root.$firebaseRefs.account.child(invoiceViaAccount.bank).set(bank);
                          invoiceViaAccount.liabilityType = this.addition;
                          let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
                          liabilityData['invoiceIdBank'] = res.key;
                          liabilityData['amountFromBank'] = invoiceViaAccount['totalAmount'];
                          liabilityData['bank'] = invoiceViaAccount['bank'];
                          self.additionAmount = null;
                          self.selectedFirmFromAsset = null;
                          self.staffRemark = null;
                  }else{
  
                      // CASHwithBank Account    
  
                      let invoiceData = {
                            brand: this.selectedBrand,
                            brandFinYear : this.brandFinYear,
                            firm:this.selectedFirmFromAsset,
                            type:'automatic invoice',
                            transactionType: 'Staff',
                            isCredited:false,
                            remark: this.staffRemark,
                            staffkey: this.selectStaff,
                            staffType: globStaffType,
                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                        }
  
                          //CASH *************************************
                          var firm = this.firmById[invoiceData.firm];
  
                          const invoiceCash = {...invoiceData}
                          invoiceCash.paymentType = "CashAndBank Account";
                          invoiceCash.totalAmount =  Number(this.operationAmountFromCash)
                          invoiceCash.amountFromCash = Number(this.operationAmountFromCash)
                      
                          firm.amount = firm && firm.amount - invoiceCash.totalAmount;
                          this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
                          invoiceCash.liabilityType = this.addition;
                          let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
                          liabilityData['invoiceIdCash'] = res.key;
                          liabilityData['amountFromCash'] = invoiceCash['totalAmount']
                          // BANK **************************************
                          const invoiceBank = {...invoiceData}
                          invoiceBank.paymentType = "Bank Account";
                          invoiceBank.totalAmount =  Number(this.operationAmountFromBank)
                          invoiceBank.amountFromBank = Number(this.operationAmountFromBank)
                          invoiceBank.bank = this.operationAccountForTransaction
  
                          if(invoiceBank.bank) {
                              invoiceBank.accountNumber = this.bankById[invoiceBank.bank].accountnumber;
                          }
                          
                          var bank = this.bankById[invoiceBank.bank];
                          bank.amount = bank && bank.amount - invoiceBank.totalAmount;
                          this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
                          invoiceBank.liabilityType = this.addition;
                          res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                          liabilityData['invoiceIdBank'] = res.key;
                          liabilityData['amountFromBank'] = invoiceBank['totalAmount'];
                          liabilityData['bank'] = invoiceBank['bank'];
                          self.additionAmount = null;
                          self.selectedFirmFromAsset = null;
                          self.staffRemark = null;
                  }
               
              }else{
                  
                  liabilityData.isCredited = false;
  
                  if(this.operationPaymentType == 'Cash'){  
                      
                      const invoiceCashData = {
                          brand: this.selectedBrand,
                          brandFinYear : this.brandFinYear,
                          firm: this.selectedFirmFromAsset,
                          type:'automatic invoice',
                          transactionType: 'Staff',
                          paymentType:this.operationPaymentType,
                          accountNumber:'',
                          isCredited:true,
                          totalAmount:Number(this.additionAmount),
                          remark: this.staffRemark,
                          staffkey: this.selectStaff,
                          staffType: globStaffType,
                          date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now(),
                      }
  
                          var firm = this.firmById[invoiceCashData.firm];
                          firm.amount = firm && firm.amount + invoiceCashData.totalAmount;
                          this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);
  
                          invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                          invoiceCashData.liabilityType = this.addition;
                          let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData); 
                          liabilityData['amountFromCash'] = invoiceCashData['totalAmount']
                          liabilityData['invoiceIdCash'] = res.key;             
                  }else if(this.operationPaymentType == 'Bank Account'){
                      
                      let invoiceViaAccount = {
                            brand: this.selectedBrand,
                            brandFinYear : this.brandFinYear,
                            firm:this.selectedFirmFromAsset,
                            type:'automatic invoice',
                            transactionType: 'Staff',
                            paymentType:this.operationPaymentType,
                            isCredited:true,
                            totalAmount:Number(this.additionAmount),
                            remark: this.staffRemark,
                            staffkey: this.selectStaff,
                            staffType: globStaffType,
                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                        }
  
                          invoiceViaAccount.amountFromBank = invoiceViaAccount.totalAmount;
                          invoiceViaAccount.bank = this.operationAccountForTransaction
  
                          if(invoiceViaAccount.bank) {
                              invoiceViaAccount.accountNumber = this.bankById[invoiceViaAccount.bank].accountnumber;
                          }
  
                          var firm = this.firmById[invoiceViaAccount.firm];
                          var bank = this.bankById[invoiceViaAccount.bank];
  
                          bank.amount = bank && bank.amount + invoiceViaAccount.totalAmount;
                          this.$root.$firebaseRefs.account.child(invoiceViaAccount.bank).set(bank);
                          invoiceViaAccount.liabilityType = this.addition;
                          let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
                          liabilityData['invoiceIdBank'] = res.key;
                          liabilityData['amountFromBank'] = invoiceViaAccount['totalAmount'];
                          liabilityData['bank'] = invoiceViaAccount['bank'];
                          self.additionAmount = null;
                          self.selectedFirmFromAsset = null;
                          self.staffRemark = null;
                  }else{
  
                      // CASHwithBank Account    
  
                      let invoiceData = {
                            brand: this.selectedBrand,
                            brandFinYear : this.brandFinYear,
                            firm:this.selectedFirmFromAsset,
                            type:'automatic invoice',
                            transactionType: 'Staff',
                            isCredited:true,
                            remark: this.staffRemark,
                            staffkey: this.selectStaff,
                            staffType: globStaffType,
                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                        }
  
                          //CASH *************************************
                          var firm = this.firmById[invoiceData.firm];
  
                          const invoiceCash = {...invoiceData}
                          invoiceCash.paymentType = "CashAndBank Account";
                          invoiceCash.totalAmount =  Number(this.operationAmountFromCash)
                          invoiceCash.amountFromCash = Number(this.operationAmountFromCash)
                      
                          firm.amount = firm && firm.amount + invoiceCash.totalAmount;
                          this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
                          invoiceCash.liabilityType = this.addition;
                          let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
                          liabilityData['amountFromCash'] = invoiceCash['totalAmount']
                          liabilityData['invoiceIdCash'] = res.key;
                          // BANK **************************************
                          const invoiceBank = {...invoiceData}
                          invoiceBank.paymentType = "Bank Account";
                          invoiceBank.totalAmount =  Number(this.operationAmountFromBank)
                          invoiceBank.amountFromBank = Number(this.operationAmountFromBank)
                          invoiceBank.bank = this.operationAccountForTransaction
  
                          if(invoiceBank.bank) {
                              invoiceBank.accountNumber = this.bankById[invoiceBank.bank].accountnumber;
                          }
                          
                          var bank = this.bankById[invoiceBank.bank];
                          bank.amount = bank && bank.amount + invoiceBank.totalAmount;
                          this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
                          invoiceBank.liabilityType = this.addition;
                          res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                          liabilityData['invoiceIdBank'] = res.key;
                          liabilityData['amountFromBank'] = invoiceBank['totalAmount'];
                          liabilityData['bank'] = invoiceBank['bank'];
                          self.additionAmount = null;
                          self.selectedFirmFromAsset = null;
                          self.staffRemark = null;
                  }
              }
  
              this.$root.$firebaseRefs.liabilitys.push(liabilityData);
              // close modal
              this.$emit('notify', "Transaction Successful", true);
              this.reset(true);
          },
          notify(ar1,ar2){
              this.$emit('notify',ar1,ar2);
          },
          reset(close = true) {
              this.selectedFirmFromAsset = null;
              this.selectAccountFromAsset = null;
              this.selectAsset = null;
              this.staffRemark =null;
              this.operationPaymentType = null;
              this.amountFromCash = null;
              this.amountFromBank = null;
              this.addition = null;
              this.additionAmount = null;
              this.deletionAmount = null;
              this.operationAccountForTransaction = null;
              this.operationAmountFromCash = null;
              this.operationAmountFromBank = null;
              let today = new Date()
              this.liabilityInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`;
              this.asset = {};
              if(close) {
                  this.$emit('closedialog');
              }
          }
      }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/InvoiceManagement/tabs/liability.vue